import { Stats } from '../common/system/stats';
import { WebGL } from '../client/system/webgl';
import { Physics as ammo } from '../common/system/ammo-physics';
import { Controller as ammocontroller } from '../client/system/ammo-controller';
import { Items } from '../common/system/items';
import { Input } from '../client/system/input';

import { Run } from '../client/index';
import * as components from '../common/component';
import '../client/engine/ui/index.tsx';

const hash = window.location.hash;
const game = hash.length > 0 ? hash.slice(1) : 'default';

Run({
    components,
    systems: {
        stats: Stats,
        items: Items,
        input: Input,
        ammo,
        ammocontroller,
        webgl: WebGL
    },
    ticker: (callback: () => void) => {
        requestAnimationFrame(callback);
    },
    game: `content/game/${game}.toml`
});



// WEBPACK FOOTER //
// ./src/xample/index.ts